import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import EditorialMarquee from "@/components/site/EditorialMarquee";
import Manifesto from "@/components/site/Manifesto";
import BotanicalCarousel from "@/components/site/BotanicalCarousel";
import Science from "@/components/site/Science";
import Sustainability from "@/components/site/Sustainability";
import PartnerPortal from "@/components/site/PartnerPortal";
import Footer from "@/components/site/Footer";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="App grain bg-[#062516]">
      <Toaster position="top-center" richColors />
      <Navbar />
      <main>
        <Hero />
        <EditorialMarquee />
        <Manifesto />
        <BotanicalCarousel />
        <Science />
        <Sustainability />
        <PartnerPortal />
      </main>
      <Footer />
    </div>
  );
}

export default App;
